import React, { useState, useEffect } from 'react';
import { colors } from '../styles/colors';
import { fonts, fontWeights } from '../styles/fonts';
import { content } from '../constants/content';

function Technology() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section id="technology" style={isMobile ? styles.sectionMobile : styles.section}>
      <h2 style={isMobile ? styles.titleMobile : styles.title}>
        {content.technology.title}
      </h2>
      
      <p style={isMobile ? styles.subtitleMobile : styles.subtitle}>
        {content.technology.subtitle}
      </p>
      
      <div style={isMobile ? styles.gridMobile : styles.grid}>
        {content.technology.features.map((feature, index) => (
          <div key={index} style={isMobile ? styles.cardMobile : styles.card}>
            <h3 style={isMobile ? styles.cardTitleMobile : styles.cardTitle}>
              {feature.title}
            </h3>
            <h4 style={isMobile ? styles.cardSubtitleMobile : styles.cardSubtitle}>
              {feature.subtitle}
            </h4>
            <p style={isMobile ? styles.cardDescriptionMobile : styles.cardDescription}>
              {feature.description}
            </p>
          </div>
        ))}
      </div>

      <div style={isMobile ? styles.diagramSectionMobile : styles.diagramSection}>
        <h3 style={isMobile ? styles.diagramTitleMobile : styles.diagramTitle}>
          System Architecture
        </h3>
        <p style={isMobile ? styles.diagramSubtitleMobile : styles.diagramSubtitle}>
          Comprehensive biomass power generation and absorption refrigeration water system
        </p>
        <div style={isMobile ? styles.diagramContainerMobile : styles.diagramContainer}>
          <img
            src="/figure1.png"
            alt="System Architecture Figure 1"
            style={styles.diagram}
          />
          <p style={isMobile ? styles.figureLabelMobile : styles.figureLabel}>Fig 1</p>
        </div>
        <div style={isMobile ? styles.diagramContainerMobile : {...styles.diagramContainer, marginTop: '30px'}}>
          <img
            src="/system-diagram.png"
            alt="Biomass Power Generation and Absorption Refrigeration Water System"
            style={styles.diagram}
          />
          <p style={isMobile ? styles.figureLabelMobile : styles.figureLabel}>Fig 2</p>
        </div>
      </div>
    </section>
  );
}

const styles = {
  section: {
    padding: '80px 60px',
    backgroundColor: colors.white,
    textAlign: 'center',
  },
  sectionMobile: {
    padding: '40px 20px',
    backgroundColor: colors.white,
    textAlign: 'center',
  },
  title: {
    fontSize: '48px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '30px',
  },
  titleMobile: {
    fontSize: '32px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '20px',
    lineHeight: '1.2',
  },
  subtitle: {
    fontSize: '18px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    maxWidth: '900px',
    margin: '0 auto 60px auto',
    lineHeight: '1.6',
  },
  subtitleMobile: {
    fontSize: '16px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    maxWidth: '100%',
    margin: '0 auto 40px auto',
    lineHeight: '1.6',
    padding: '0 10px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '30px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  gridMobile: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    maxWidth: '100%',
    margin: '0 auto',
  },
  card: {
    padding: '40px 30px',
    backgroundColor: colors.white,
    border: `2px solid ${colors.primary}`,
    borderRadius: '12px',
    textAlign: 'left',
  },
  cardMobile: {
    padding: '25px 20px',
    backgroundColor: colors.white,
    border: `2px solid ${colors.primary}`,
    borderRadius: '12px',
    textAlign: 'left',
    width: '100%',
  },
  cardTitle: {
    fontSize: '22px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '10px',
  },
  cardTitleMobile: {
    fontSize: '20px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '8px',
  },
  cardSubtitle: {
    fontSize: '16px',
    fontWeight: fontWeights.medium,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    marginBottom: '15px',
  },
  cardSubtitleMobile: {
    fontSize: '14px',
    fontWeight: fontWeights.medium,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    marginBottom: '12px',
  },
  cardDescription: {
    fontSize: '16px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    lineHeight: '1.6',
  },
  cardDescriptionMobile: {
    fontSize: '15px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    lineHeight: '1.5',
  },
  diagramSection: {
    marginTop: '80px',
    maxWidth: '1200px',
    margin: '80px auto 0',
  },
  diagramSectionMobile: {
    marginTop: '60px',
    maxWidth: '100%',
    margin: '60px auto 0',
  },
  diagramTitle: {
    fontSize: '36px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '20px',
  },
  diagramTitleMobile: {
    fontSize: '28px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '15px',
    lineHeight: '1.2',
  },
  diagramSubtitle: {
    fontSize: '16px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    marginBottom: '40px',
    lineHeight: '1.6',
  },
  diagramSubtitleMobile: {
    fontSize: '14px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    marginBottom: '30px',
    lineHeight: '1.5',
    padding: '0 10px',
  },
  diagramContainer: {
    backgroundColor: colors.white,
    border: `2px solid ${colors.primary}`,
    borderRadius: '12px',
    padding: '40px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  diagramContainerMobile: {
    backgroundColor: colors.white,
    border: `2px solid ${colors.primary}`,
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  diagram: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
  figureLabel: {
    fontSize: '16px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginTop: '16px',
    marginBottom: '0',
    textAlign: 'center',
  },
  figureLabelMobile: {
    fontSize: '14px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginTop: '12px',
    marginBottom: '0',
    textAlign: 'center',
  },
};

export default Technology;